export const total = (a: any[], kayName: string): number => {
  const result = a.map((item) => item[kayName]).reduce((prev, curr) => prev + curr, 0);
  return Number(result);
};
